<template>
    <ul class="selected-template-properties checkbox-group">
        <li v-for="(property, key) in templateDataFiltered" :key="key">
            <span :class="['pointer', 'far', property.selected ? 'fa-check-square' : 'fa-square']" @click="toggleProperty(key)"></span>
            <label>{{ property.label }} <span v-if="getDisplayValue(property)">: {{ getDisplayValue(property) }}</span></label>
        </li>
    </ul>
</template>
 
<script>
const CONDITION = [
  { id: 1, label: "Factory New" },
  { id: 2, label: "New Old Stock" },
  { id: 3, label: "Used" },
];
const AUTO_RELIST = [
	{ id: 1, label: "Do Not Relist" },
	{ id: 2, label: "Relist Until Sold" },
	{ id: 3, label: "Relist Fixed Count" },
	{ id: 4, label: "Relist Fixed Price" },
];
const WHO_PAYS_FOR_SHIPPING = [
	{ id: 2, label: "Seller pays for shipping" },
	{ id: 3, label: "Seller pays for shipping (see item description)" },
	{ id: 4, label: "Buyer pays actual shipping cost" },
	{ id: 5, label: "Buyer pays actual shipping cost (see item description)" },
	{ id: 8, label: "Buyer pays fixed amount" },
	{ id: 9, label: "Buyer pays fixed amount (see item description)" },
];
const WEIGHT_UNIT = [
  { id: 1, label: "Pounds" },
  { id: 2, label: "Kilograms" },
];
const INSPECTION_PERIODS = [
	{ id: 1, label: "AS IS No refund or exchange" },
	{ id: 2, label: "No refund but item can be returned for exchange or store credit within fourteen days" },
	{ id: 3, label: "No refund but item can be returned for exchange or store credit within thirty days" },
	{ id: 4, label: "Three Days from the date the item is received" },
	{ id: 5, label: "Three Days from the date the item is received, including the cost of shipping" },
	{ id: 6, label: "Five Days from the date the item is received" },
	{ id: 7, label: "Five Days from the date the item is received, including the cost of shipping" },
	{ id: 8, label: "Seven Days from the date the item is received" },
	{ id: 9, label: "Seven Days from the date the item is received, including the cost of shipping" },
	{ id: 10, label: "Fourteen Days from the date the item is received" },
	{ id: 11, label: "Fourteen Days from the date the item is received, including the cost of shipping" },
	{ id: 12, label: "30 day money back guarantee" },
	{ id: 13, label: "30 day money back guarantee including the cost of shipping" },
	{ id: 14, label: "Factory Warranty" },
];
export default {
    name: "SelectedTemplateProperties",
    props: {
        templateData: {
            type: Object,
            required: true
        },
    },
    computed: {
        templateDataFiltered() {
            return Object.fromEntries(Object.entries(this.templateData).filter(([key, value]) => value.label && value.label.length > 0));
        }
    },
    methods: {
        toggleProperty(key) {
            console.log(this.templateData[key].selected);
            this.$set(this.templateData[key], 'selected', !this.templateData[key].selected);
            this.$emit('update:templateData', this.templateData);
        },
        getDisplayValue(property) {
            if (!property || !property.label) return null;

            const map = {
                "GunBroker Category": "CategoryName"
            };

            if (property.label === "Condition") {
                const condition = CONDITION.find(c => c.id === property.data);
                return condition ? condition.label : null;
            }
            if (property.label === "Auto Relist") {
                const AutoRelist = AUTO_RELIST.find(c => c.id === property.data);
                return AutoRelist ? AutoRelist.label : null;
            }
            if (property.label === "Who Pays for Shipping") {
                const WhoPaysForShipping = WHO_PAYS_FOR_SHIPPING.find(c => c.id === property.data);
                return WhoPaysForShipping ? WhoPaysForShipping.label : null;
            }
            if (property.label === "Weight unit") {
                const WeightUnit = WEIGHT_UNIT.find(c => c.id === property.data);
                return WeightUnit ? WeightUnit.label : null;
            }
            if (property.label === "Inspection Period") {
                const InspectionPeriod = INSPECTION_PERIODS.find(c => c.id === property.data);
                return InspectionPeriod ? InspectionPeriod.label : null;
            }

            if (property.label === "Payment Methods") {
            return Object.keys(property.data || {})
                .filter(method => property.data[method] === true)
                .join(", ");
            }

            if (property.label === "Listing Duration") {
                return property.data ? `${property.data} day${property.data > 1 ? 's' : ''}` : null;
            }

            if (property.label === "Shipping Class Costs") {
            return Object.entries(property.data || {})
                .filter(([key, value]) => value !== null)      // only keep non-null
                .map(([key, value]) => `${key}: ${value}`)    // format key + value
                .join(", "); 
            }

            if (property.label === "Supported Shipping Classes") {
            return Object.keys(property.data || {})
                .filter(method => property.data[method] !== null)
                .join(", ");
            }

            const key = map[property.label];
            return key ? property.data?.[key] : property.data;
        }
    }
}
</script>

<style lang="scss" scoped>
li {
    label {
        display: inline-flex;
        flex-direction: row-reverse;
        justify-content: flex-end;
        gap: 0.4em;
    }
}
</style>

<style lang="scss" scoped>
.selected-template-properties.checkbox-group span:not(:first-of-type) {
    margin: 0 0 0 0 !important;
}
ul {
    columns: 2;
    li {
        display: grid;
        grid-auto-flow: column;
        grid-template-columns: 0.5em auto;
        gap: 0.5em;
        label {
            display: inline-block;
        }
    }
}
</style>